import { render, staticRenderFns } from "./SystemConfigExtends.vue?vue&type=template&id=253e4b8c"
import script from "./SystemConfigExtends.vue?vue&type=script&lang=js"
export * from "./SystemConfigExtends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports